import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AddRequestedLoan } from 'services/loans'
interface IMutationFnPayload extends IAddLoanPayload {
    id: string
}
export default function useSetRequestedLoan() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IMutationFnPayload) => {
            return AddRequestedLoan(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('وام درخواستی با موفقیت ثبت شد')
            navigate(-1)
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
